import dayjs from "dayjs";
import type { ChallengeInfo } from "@/sales-tools/challenges/api/getChallengesForEmployee";

/**
 * Upserts a challenge if fresher information exists
 * If no matching id is found, add it to the list
 * If a matching id is found but the new challenge is older than the current challenge info, discard it
 * If a matching id is found and its fresher than the current challenge info, replace it
 */
export const upsertChallengeIfFresh = (
    challengeUpdate: ChallengeInfo,
    currentChallenges?: ChallengeInfo[],
): ChallengeInfo[] => {
    if (!currentChallenges) return [challengeUpdate];

    const index = currentChallenges.findIndex((c) => c.challengeId === challengeUpdate.challengeId);

    if (index === -1) return [...currentChallenges, challengeUpdate];

    return dayjs(currentChallenges[index].timestamp).isAfter(dayjs(challengeUpdate.timestamp))
        ? currentChallenges
        : [...currentChallenges.slice(0, index), challengeUpdate, ...currentChallenges.slice(index + 1)];
};
